export default "__VITE_ASSET__5dPC7aYX__"